import { useNavigate } from 'react-router';

const getNameForPictureOfAdmin = (user) => {
  let ShortName = "";
  if (user && user.name) {
    const AdminName = user.name;
    const arr = AdminName.split(" ");
    if (arr.length > 0) {
      const tempString = arr.map((element) => element[0]);
      ShortName = tempString.join("");
    }
    return ShortName;
  } else {
    return ShortName;
  }
};
export const calculateYears = (date) => {
  const birthDate = new Date(date);
  const today = new Date();
  let age = today.getFullYear() - birthDate.getFullYear();
  const monthDiff = today.getMonth() - birthDate.getMonth();
  if (
    monthDiff < 0 ||
    (monthDiff === 0 && today.getDate() < birthDate.getDate())
  ) {
    age--;
  }
  return age;
};

export const getCurrentYear = () => {
  const date = new Date();
  let currentYear = date.getFullYear();
  return currentYear;
};
export const AddProductModalTitleText = "Add Product ";

export const EditProductModalTitleText = "Edit Product Details";

export const AddHospitalModalText = "Add New Hospital";

export const EditHospitalModalText = "Edit Hospital";

export const FormTemplateModalText = "New Form template";

export const AddPrincipleInvestigatorModalText = "Add Principle Investigator";

export const EditPrincipleInvestigatorModalText = "Edit Principle Investigator";

export const AddImmunoActQAText = "Add ImmnoAct QA";

export const EditImmunoActQAText = "Edit ImmnoAct QA";

export const AddDiseaseManagementModalText = "Add New Disease";

export const EditDiseaseManagementModalText = "Edit Disease";

export const AddEditorManagementModalText = "Add Editor";

export const EditEditorManagementModalText = "Edit Editor";

export const ResendTrialManagementModalText = "Resend Request";

export const RejectTrialManagementModalText = "Description";

export const DescripitionTrialManagementModalText = "Description";

export const AddPhaseModalText = "Add New Phase";



export default getNameForPictureOfAdmin;

// ✅ Utility only - no hooks here
export const urlToBackWithoutState = (routeUrl, state) => {
  const navigate = useNavigate()
  // If state already provided, return it
  if (state?.length > 0) return state;

  let spllitedUrlArray = routeUrl?.split("/").filter(Boolean); // remove empty strings

  let bmr = false;
  if (spllitedUrlArray[0] === "bmr") {
    bmr = true;
    spllitedUrlArray = spllitedUrlArray.slice(1); // skip first element
  }

  const breadcrumbs = [];
  let title = "";
  let basePath = "";

  // 🟢 Case 1: view pages
  if (spllitedUrlArray.includes("view")) {
    const index = spllitedUrlArray.indexOf("view");
    basePath = `/${bmr ? "bmr/" : ""}${spllitedUrlArray.slice(0, index).join("/")}`;

    title = spllitedUrlArray.includes("in-bound")
      ? "LSM Inbound"
      : spllitedUrlArray.includes("out-bound")
      ? "LSM Outbound"
      : spllitedUrlArray[0].replace(/-/g, " ");
  }

  // 🟢 Case 2: manufacturer view
  else if (spllitedUrlArray.includes("manufacturer_view")) {
    title = "Manufacturer";
    basePath = "/bmr/manufacturer";
  }

  // 🟢 Case 3: details pages
  else if (spllitedUrlArray.includes("details")) {
    const index = spllitedUrlArray.indexOf("details");
    basePath = `/${bmr ? "bmr/" : ""}${spllitedUrlArray.slice(0, index).join("/")}`;

    title = spllitedUrlArray.includes("lsm-received")
      ? "LSM Received"
      : spllitedUrlArray.includes("approval-received")
      ? "Approved LSM"
      : spllitedUrlArray.includes("lsm")
      ? "QR Code Generation"
      : spllitedUrlArray[0].replace(/-/g, " ");
  }

  // 🟢 Case 4: qc/qa/fb
  else if (
    spllitedUrlArray.includes("qc") ||
    spllitedUrlArray.includes("qa") ||
    spllitedUrlArray.includes("fb")
  ) {
    const index =
      spllitedUrlArray.indexOf("qc") >= 0
        ? spllitedUrlArray.indexOf("qc")
        : spllitedUrlArray.indexOf("qa") >= 0
        ? spllitedUrlArray.indexOf("qa")
        : spllitedUrlArray.indexOf("fb");

    basePath = `/${bmr ? "bmr/" : ""}${spllitedUrlArray.slice(0, index + 1).join("/")}`;

    title = spllitedUrlArray.includes("qa")
      ? "Quality Approved"
      : spllitedUrlArray.includes("fb")
      ? "Form Management"
      : "Quality Control";
  }

  // 🟢 Case 5: fallback
  else {
    basePath = `/${bmr ? "bmr/" : ""}${spllitedUrlArray.join("/")}`;
    title = spllitedUrlArray[0]?.replace(/-/g, " ");
  }

  // Push base breadcrumb
  if (basePath && title) {
    breadcrumbs.push({
      name: title,
      path: basePath,
    });
  }
    breadcrumbs.push({
      name: "Details",
      path: routeUrl,
    });
    navigate(routeUrl, { state: breadcrumbs },true)
  return breadcrumbs;
};

export const UrlToRouteArrayConverter = (phaseDetails, routeUrl) => {
  let productDetails = phaseDetails?.product_details;
  let BreadCrumbArray = [];
  if (routeUrl) {
    let spllitedUrlArray = routeUrl?.split("/");
    spllitedUrlArray.forEach((path, index) => {
      let DetailPageBoolean = false;
      let pathobj = {};
      if (
        spllitedUrlArray[index - 1]?.length > 0 &&
        spllitedUrlArray[index].includes(spllitedUrlArray[index - 1])
      ) {
        DetailPageBoolean = true;
      }
      if (isNaN(Number(path))) {
        let splittedPathArray = path?.split("-");
        splittedPathArray = splittedPathArray?.map(
          (word) => word?.charAt(0).toUpperCase() + word?.slice(1)
        );

        let joinedPathString = splittedPathArray?.join(" ");
        if (joinedPathString === "Product Details") {
          if (productDetails?.id == spllitedUrlArray[index + 1]) {
            pathobj.name = `${productDetails?.name[0]?.toUpperCase() + productDetails?.name.slice(1) + " " || ""}Details`;
          } else {
            pathobj.name = "Details";
          }
        } else if (joinedPathString === "Trials") {
          pathobj.name = `${phaseDetails?.title || ""}`;
        }
        else if (joinedPathString === "Assigned Editors" || joinedPathString === "Editor Management") {
          pathobj.name = 'Editor';
        }
        else if (joinedPathString === "Patient Details") {
          pathobj.name = 'Patient Details';
        }
        else if (joinedPathString === "Role Details") {
          pathobj.name = 'Role Details';
        }
        else if (joinedPathString === "Feasibility Assessment") {
          pathobj.name = 'Feasibility Assessment';
        }
        else {
          if (DetailPageBoolean) {
            pathobj.name = "Details";
          } else {
            pathobj.name = joinedPathString;
          }
        }
        if (!isNaN(spllitedUrlArray[index + 1])) {
          let pathArray = spllitedUrlArray.slice(1, index + 2);
          let pathString = pathArray.join("/");
          pathobj.path = pathString;
        } else {
          pathobj.path = `${spllitedUrlArray[index]}`;
        }
        BreadCrumbArray.push(pathobj);
      }
    });
  }
  return BreadCrumbArray;
};

export const FormBreadCrumbGetter = (routeUrl, phaseDetails) => {

  let BreadCrumbArray = [];
  if (routeUrl) {
    let spllitedUrlArray = routeUrl?.split("/");
    spllitedUrlArray.forEach((path, index) => {
      let pathobj = {};
      if (isNaN(Number(path))) {
        let splittedPathArray = path?.split("-");
        splittedPathArray = splittedPathArray?.map(
          (word) => word?.charAt(0).toUpperCase() + word?.slice(1)
        );

        let joinedPathString = splittedPathArray?.join(" ");
        if (
          joinedPathString === "Create Form Builder"
        ) {
          pathobj.name = "Add New Form";
        } else if (joinedPathString === "Form Builder Preview") {
          pathobj.name = "Preview";
        } else if (joinedPathString === "Product Details") {
          if (phaseDetails)
            pathobj.name = phaseDetails?.product_details?.name + " Details";
        }
        else {
          pathobj.name = joinedPathString;
        }
        if (!isNaN(spllitedUrlArray[index + 1])) {
          let pathArray = spllitedUrlArray.slice(1, index + 2);
          let pathString = pathArray.join("/");
          pathobj.path = pathString;
        } else {
          pathobj.path = `${spllitedUrlArray[index]}`;
        }
        BreadCrumbArray.push(pathobj);
      }
    });
  }
  return BreadCrumbArray;
};
